import { render, staticRenderFns } from "./SendingSmsWithMobilePhoneInformation.vue?vue&type=template&id=21294dab"
import script from "./SendingSmsWithMobilePhoneInformation.vue?vue&type=script&lang=js"
export * from "./SendingSmsWithMobilePhoneInformation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports